import { customerData } from '../../utilities/CustomerData'
import { showPendingCalcWindow, shouldShowPayInvoiceButton, shouldShowPostpaidStyleReauthorizeFlow } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

const REAUTH_TURNKEY_STAGE_ID = 'a1b2c3d4-3333-4aaa-bbbb-reauth0003tk'

export default function DashboardTopBar({ reauthTurnkeyNeedsAction = false }) {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex max-sm:flex-col flex-row justify-between gap-5'>
      {(customerData.customerLeadData.leadType !== 'Leads' && !showPendingCalcWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true))) ? (
        <div className='flex-1 flex flex-col relative text-[#74be43] p-4'>
          <div className='relative flex items-center w-full'>
            <p className='text-lg font-bold text-center w-full'>Calculated Refund</p>
          </div>
          <p className='text-center font-bold text-6xl mt-auto'>${customerData.customerLeadData.leadAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}</p>
          {customerData.customerDocuments.irsBalance > 0 && (
            <p className='font-bold text-xl text-[#898989] text-center mt-2'>IRS balance ${customerData.customerDocuments.irsBalance.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerDocuments.irsBalance % 1 !== 0 ? 2 : 0})}</p>
          )}
          {customerData.customerInvoiceData?.invoiceId && !customerData.customerInvoiceData?.invoicePaid && (
            <p className='font-bold text-2xl text-[#FF8C00] text-center mt-2'>Invoice balance ${customerData.customerInvoiceData.invoiceAmount.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerInvoiceData.invoiceAmount % 1 !== 0 ? 2 : 0})}</p>
          )}
        </div>
      ) : (
        <div className='flex-1 flex flex-col p-4'>
          <div className='relative flex items-center w-full'>
            <p className='text-lg font-bold text-center w-full text-[#7C7D7F]'>Estimated Refund</p>
          </div>
          <p className='text-gray-600 text-center font-bold text-6xl'>${customerData.customerLeadData.leadEstimateRefund.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: customerData.customerLeadData.leadAmount % 1 !== 0 ? 2 : 0})}</p>
        </div>
      )}
      {window.innerWidth > 768 && (
        shouldShowPayInvoiceButton() ? (
          <div className='shadow-full rounded-xl p-4 bg-white flex-1 flex flex-col relative justify-center gap-3'>
            <button onClick={() => navigate('/paymentPortal')} className='px-6 py-3 bg-[#FF8C00] text-white font-semibold rounded-lg shadow hover:bg-[#e67600] transition'>
              Pay Invoice
            </button>
            {(shouldShowPostpaidStyleReauthorizeFlow(customerData.customerLeadData.leadStage?.leadStageId) || (customerData.customerLeadData.leadStage?.leadStageId === REAUTH_TURNKEY_STAGE_ID && reauthTurnkeyNeedsAction)) && (
              <button onClick={() => navigate('/reauth/id-verification')} className='px-6 py-3 bg-[#5186C0] text-white font-semibold rounded-lg shadow hover:bg-[#4070A0] transition'>
                Reauthorize Account
              </button>
            )}
          </div>
        ) : (
          <div className='shadow-full rounded-xl p-4 bg-white flex-1 flex flex-col relative justify-around gap-3'>
            <p className='text-xl text-center font-bold text-[#646464]'>Refund Stage</p>
            <p className={`text-[${customerData.getCustomerStageName().color}] text-center font-bold text-3xl`}>{customerData.getCustomerStageName().text}</p>
            {(customerData.customerLeadData.leadStage?.leadStageId === REAUTH_TURNKEY_STAGE_ID && reauthTurnkeyNeedsAction) && (
              <button onClick={() => navigate('/reauth/id-verification')} className='px-6 py-3 bg-[#5186C0] text-white font-semibold rounded-lg shadow hover:bg-[#4070A0] transition'>
                Reauthorize Account
              </button>
            )}
          </div>
        )
      )}
    </div>
  )
}
